<template>
<div class="container-fluid" >
  <waitingModal v-if="waitModal.show" @close="closeWaitingModal()"  v-bind:props="waitModal"></waitingModal>
  <supplierDocuments v-if="supplierDocuments.show" @close="supplierDocuments=supplierDocuments.show=false" v-bind:props="supplierDocuments"></supplierDocuments>
 <div class="card border-success">

  <div class="card-header text-white bg-primary">
    <h4><i style="color:#FFD700" class="fas fa-chart-pie mr-2" aria-hidden="true"></i>ACQUISTATO/VENDUTO NEL PERIODO</h4>
  </div> 

 <div  class="card-body"> 
  
   <div class="row">
   <div v-if="items.length==0"  class="col"> 

  <div class="card border-info" >
  <div class="card-header bg-info">
    <i style="color:yellow" class="fas fa-stream mr-2" aria-hidden="true"></i>
    <strong>PARAMETRI DI RICERCA</strong></div>
  <div class="card-body text-dark">   

  <form name="filter" v-on:submit.prevent="submit()">
    <store-select v-bind:props="store"  @update="setStoreId"></store-select>
  <div class="form-row">  
    
  <div class="col-md-3">
    <supplier-select v-bind:props="supplier" @update="setSupplierId"></supplier-select>
  </div>
  
  <div class="col-md-3">
    <supplier-brand-list :key="refresh"  v-bind:props="brand" @update="setBrandId"></supplier-brand-list>
  </div>
  
  

  
  </div>
  <button v-if="1==0" :disabled="supplier.Id==0 || season.Ids.length == 0" @click="getDataDocuments()" type="button" class="btn btn-warning mb-2">
    <i class="fas fa-folder-open mr-2"></i>
      LISTA DOCUMENTI DI ACQUISTO
      <span v-if="spinner_pdf" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
  </button>  

    <div class="form-row">

    <div class="col-md-3">  
    <div class="form-group">
      <label for="date_doc"><strong>DATA PRIMO ACQUISTO</strong></label>
      <input @change="setData3()" :disabled="items.length>0" required v-model="data1" type="date" class="form-control" placeholder="" >        
    </div>
    </div>

    <div class="col-md-3">  
    <div class="form-group">
      <label for="date_doc"><strong>DATA ULTIMO ACQUISTO / RESO A FORNITORE </strong></label>
      <input :disabled="items.length>0" required v-model="data2" type="date" class="form-control" placeholder="" >        
    </div>
    </div>
    <div class="col-md-3">  
    <div class="form-group">
      <label for="date_doc"><strong>DATA PRIMA VENDITA </strong></label>
      <input :disabled="items.length>0" required v-model="data3" type="date" class="form-control" placeholder="" >        
    </div>
    </div>
    
    <div class="col-md-3">  
      <div class="form-group">
        <label for="date_doc"><strong>DATA ULTIMA VENDITA </strong></label>
        <input :disabled="items.length>0" required v-model="data4" type="date" class="form-control" placeholder="" >   
     
      </div>  
    </div>



    </div>

  <div class="row">
  <div class="col-md-2">    
    <season-vue-select  @update="setSeasonId" v-bind:props="season"></season-vue-select>
  </div>
  <div class="col-md-2">      
    <yearVueSelect @update="setYear" v-bind:props="season_year"></yearVueSelect>
  </div>  
  <div class="col-md-2">
      <department-select v-bind:props="department" @update="setDepartmentId"></department-select>  
  </div>  
  <div class="col-md-3">
      <div class="form-group">
        <category-grouping v-bind:props="catGrouping" @update="setGroupCategoryId"></category-grouping>
      </div>
    </div>
    <div class="col-md-3">
      <div class="form-group">
        <category-select v-bind:props="category"  @update="setCategoryId"></category-select>    
      </div>
    </div>
    


  </div>
  <div class="form-row">
    <div class="col-md-3">
      <div class="form-group">
        <line-select :key="refreshLine" v-bind:optionBase="true"  v-bind:Id="lineId" v-bind:supplierId="supplier.Id"  @update="setLineId"></line-select>
      </div>
    </div>        
   

  </div>    
    <span><strong>TIPO RAGGRUPPAMENTO</strong></span>  
    <div  v-for="(item,index) in grouping" :key="index">  
      <div class="form-check">
        <input @change="setGroup($event)" type="radio" class="form-check-input" :id="'group_by_' + index" :value="index" v-model="group_by">
        <label class="form-check-label"  :for="'group_by_' + index">{{item.group_by}}</label>
      </div>
    </div>
   
      
    <div class="card-footer bg-transparent border-info"> 
      <alert-box class="mt-2" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>
   <button :disabled="spinner" type="submit"  class="btn btn-primary ">
    <i class="far fa-play-circle mr-2"></i>
    ESEGUI
      <span v-if="spinner" class="spinner-border spinner-border-sm text-warning ml-3" role="status" aria-hidden="true"></span>
     </button>           
     
  <!--
    <button @click="items=[],row_total=[],component=''" type="button"   class="btn btn-outline-secondary ">
       <i class="fas fa-redo-alt mr-2"></i>     
        RESET
    </button>   
    -->
  </div>
  </form>

  </div>
  </div>
  </div>

<div v-else class="col">
  <cancel-btn  @click="refreshData()" v-bind:text="'RITORNA A PARAMETRI RICERCA'" class="mb-1"></cancel-btn>
  <div class="row">
    
    <div v-if="1==0">
      <div v-if="!onlySelection">
      <span > <strong>Click seleziona riga prodotto</strong></span>
    </div>
    <div v-else>
      <button  :disabled="onlySelection==false" @click="setSelection()" type="button"   class="btn btn-success   mb-1  mr-3">
      <i class="fas fa-eraser mr-2"></i>
        ANNULLA SELEZIONE         
      </button> 
      
    </div>

    </div>


    <div class="custom-control custom-checkbox mr-4 mt-2 ml-4">
      <input v-model="checkHide" type="checkbox" class="custom-control-input" id="customCheck1">
      <label class="custom-control-label" for="customCheck1">MOSTRA SOLAMENTE QUANTITA' SU PDF.</label>
    </div>  
    <div v-if="1==0" class="custom-control custom-checkbox mr-4 mt-2">
      <input v-model="onlySelection" type="checkbox" class="custom-control-input" id="customCheck2">
      <label class="custom-control-label" for="customCheck2">MOSTRA SOLAMENTE SELEZIONE PRODOTTI</label>
    </div>  

    <button  :disabled="items.length==0 || spinner_pdf == true" @click="pdf()" type="button"   class="btn btn-primary  mb-1  mr-3">
      <i class="fas fa-file-export mr-2"></i>
        ESPORTA PDF
        <span v-if="spinner_pdf" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>       
    </button>
   <button v-if="1==0"  :disabled="spinner_csv == true" @click="exportToCSV()" type="button"   class="btn btn-success  mb-1  mr-3">
      <i class="fas fa-file-export mr-2"></i>
        ESPORTA CSV
        <span v-if="spinner_csv" class="spinner-border spinner-border-sm ml-4" role="status" aria-hidden="true"></span>       
    </button>
   
    
    
  
  </div>
  
   <product-img v-if="img" @close="img=''" v-bind:img='img'></product-img>    
   <div class="table-wrapper-scroll-y my-custom-scrollbar">

  <table id='my-table1' class="table table table-hover_ table-striped_ mb-0">
    <thead >
      <tr class="table-primary">
        
        <!--
        <th scope="col"></th>  
        -->
        <th scope="col">#</th>
        <th></th>  
        <th class="text-nowrap"  scope="col">ID PROD.</th>
        <th scope="col"></th>
        <th  class="text-nowrap" scope="col">SKU</th>
        <th scope="col">STAGIONE</th>
       <!-- <th scope="col">Anno</th>-->
        <th scope="col">REPARTO</th>
        <th scope="col">BRAND</th>
        <th scope="col">LINEA</th>
        <th scope="col">GRUPPO</th>
        <th scope="col">CATEGORIA</th>
        <th class="text-right" scope="col">ACQUISTATO</th>        
        <th class="text-right" scope="col">VENDUTO</th>
        <th class="text-right" scope="col">DELTA</th>
        
        
        <th class="text-right text-nowrap" scope="col">ACQUISTATO IE (€)</th>
        <th class="text-right text-nowrap" scope="col">VENDUTO IE (€)</th>
        <th class="text-right">BEP</th>
        <th class="text-right text-nowrap" scope="col">VENDUTO RETAIL </th>
        <th class="text-right text-nowrap" scope="col">VENDUTO ONLINE </th>
        <th class="text-right text-nowrap" scope="col">VENDUTO ONLINE (€)</th>
        
        <th class="text-right text-nowrap">COSTO VENDUTO (€)</th>
        <!--<th class="text-right" scope="col">Venduto</th>-->
        
        
        <th class="text-right" scope="col">STOCK</th>
        <th class="text-right text-nowrap" scope="col">VAL. STOCK (€)</th>
       
       <th class="text-right text-nowrap">UTILE (€)</th>
       <th class="text-right">MARGINE</th>
       
      </tr>
    </thead>
    <tbody>
      <tr @click="setDataToExport(index)" @dblclick="openDetail(index)"  :style = "{backgroundColor : item.export == 1 ? '#dbfedb' : 'white', color: item.row_type == 1  ? 'blue' : 'black',fontSize: item.row_type == 1 ? '15px':'12px',fontWeight:item.row_type == 1? 'bold':'normal' }"   data-toggle="tooltip" title="doppio click dettaglio colori " class="pointer" v-for="(item, index) in items" :key="index">
        
        <!--
        <td>
            <input v-if="item.row_type==0" class="pointer" type="checkbox"  v-model.number="item.selected">
        </td>
        -->
        
        <td>{{index+1}} 
            
            </td> 
        <td>
           
            <button v-if="item.productId" class="btn btn-default"  @click="getProductImg(item)">
            <i style='color:black;' data-toggle="tooltip" title="Image"  class="fas fa-camera" aria-hidden="true">
               
            </i>
          </button>    

           
        </td>    
        <td >{{item.productId}} </td> 
        <td ><span v-if="item.row_type==0" :class="{dotRed:item.venduto_qty == 0}"></span></td> 
        <td class="text-nowrap_"><strong> {{item.sku}}</strong>
              <div v-if="isOpen[index]==true">
          <component :key = "componentKey" v-bind:spinner="spinner1" v-bind:is="component" v-bind:cols="cols" v-bind:rows="rows"></component>          
          <span v-if="spinner1" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> 
          </div>
            
             </td>        
        <td  class="text-nowrap_">{{item.season}} {{item.season_year}}</td>        
      <!--  <td >{{item.season_year}}</td>     -->   
        <td class="text-nowrap_" >{{item.department}}</td>        
        <td class="text-nowrap_">{{item.brand}}</td>   
        <td class="text-nowrap_">{{item.line}}</td>   
        <td class="text-nowrap" >{{item.cat_grouping}} </td>        
        <td class="text-nowrap_">{{item.category}} 
        <small><p>{{ item.description }}</p></small>
        </td>
        <td class="text-right">{{fmt2(item.acquistato_qty)}} </td>        
        <td class="text-right">{{fmt2(item.venduto_qty)}}</td>
        <td class="text-right">{{item.delta_qty}}</td>
        
        
        <td class="text-right">{{fmt1(item.acquistato_value)}}</td>
        <td class="text-right">{{fmt1(item.venduto_no_iva)}}</td>
        <td :style="{color :  item.delta_venduto.substring(0,1) =='-' ? 'red':'black'}"  class="text-right">{{item.delta_venduto}} </td>
        <td class="text-right">{{fmt2(item.venduto_retail_qty)}}</td>
        <td class="text-right">{{fmt2(item.venduto_online_qty)}}</td>
        <td class="text-right">{{fmt1(item.venduto_online_value)}}</td>
        
        <td class="text-right">{{fmt1(item.costo_venduto)}} </td>        
        <td class="text-right">{{fmt2(item.stock_qty)}} </td>
        <td class="text-right">{{fmt1(item.stock_value)}} </td>        
        <td  :style="{color :  fmt1(item.utile).substring(0,1) =='-' ? 'red':'black'}" class="text-right">{{fmt1(item.utile)}} </td>
        <td class="text-right">
        <!--
          <div class="progress">
            <div class="progress-bar bg-success" style="width:100%">{{item.margine}}</div>
          </div>
        -->  
         {{item.margine}}
         
         </td>
        
       
      </tr> 
    </tbody>
    <tfoot>
        <tr  :style="{backgroundColor: item.row_type == 3 ? '#FFFFE0':'white', color: item.row_type==2  ? 'blue' : 'black',fontSize: item.row_type == 3 ? '20px':'15px',fontWeight:item.row_type == 3 ? 'bold':'normal' }"  data-toggle="tooltip" title="" class="pointer" v-for="(item, index) in row_total" :key="index"> 
        <!--
        <td> </td>
        -->
        <td> </td>

        <td> </td>
        <td> </td>
        <td> </td>
        <td class="text-nowrap"> </td>
        <td class="text-nowrap"> </td>
        <td class="text-nowrap"> </td>
        <td class="text-nowrap"> </td>
        <td class="text-nowrap"> </td>
        <td></td>
        <td>TOTALI </td>
        <td class="text-right">{{fmt2(item.acquistato_qty)}} </td>        
        <td class="text-right">{{fmt2(item.venduto_qty)}}</td>
        <td class="text-right">{{item.delta_qty}}</td>
        
        
        <td class="text-right">{{fmt1(item.acquistato_value)}}</td>
        <td class="text-right">{{fmt1(item.venduto_no_iva)}}</td>
        <td :style="{color :  item.delta_venduto.substring(0,1) =='-' ? 'red':'black'}"   class="text-right">{{item.delta_venduto}} </td>
        <td class="text-right">{{fmt2(item.venduto_retail_qty)}}</td>
        <td class="text-right">{{fmt2(item.venduto_online_qty)}}</td>
        <td class="text-right">{{fmt1(item.venduto_online_value)}}</td>
        
        <td class="text-right">{{fmt1(item.costo_venduto)}} </td>        
       
       
        <td class="text-right">{{fmt2(item.stock_qty)}} </td>
        <td class="text-right">{{fmt1(item.stock_value)}} </td>        
        <td :style="{color :  fmt1(item.utile).substring(0,1) =='-' ? 'red':'black'}" class="text-right">{{fmt1(item.utile)}} </td>
        <td class="text-right">{{item.margine}} </td>
       


        
        </tr>   
    </tfoot>    
  </table>

</div>

 

</div>  

</div>

 </div>
 </div>

</div>
</template>
<script>
//import axios             from "axios";
import api               from '@/api'
import { mapGetters }    from 'vuex';
import alertBox          from '@/components/common/AlertBox.vue';
import supplierSelect    from '@/components/common/SupplierSelect_1.vue'
//import seasonSelect      from '@/components/common/SeasonSelect_1.vue'
import seasonVueSelect   from '@/components/common/SeasonVueSelect_1.vue'
import yearVueSelect     from '@/components/common/YearVueSelect.vue'
import departmentSelect  from '@/components/common/DepartmentVueSelect_1.vue'

import storeSelect       from '@/components/common/StoreSelect_1.vue'
import jsPDF             from 'jspdf';
import productDetail     from '@/components/common/ProductDetail.vue'
import categorySelect    from '@/components/common/CategorySelect_1.vue';
import productImg        from '@/components/common/ProductImg.vue'
import supplierBrandList from '@/components/common/SupplierBrandSelect_1.vue'
import cancelBtn         from '@/components/common/CancelBtn.vue'
import supplierDocuments from '@/components/stat/SupplierSeasonDocuments.vue'
import categoryGrouping   from '@/components/common/CategoryGroupingSelect_1.vue'
import fmt                from '@/components/mixins/fmt'
import waitingModal      from "@/components/common/WaitingModal.vue"
import lineSelect        from '@/components/common/LineSelect.vue'




export default {
  mixins     : [fmt],
  components: {alertBox,supplierSelect,departmentSelect,productDetail,categorySelect,productImg,supplierBrandList,cancelBtn,supplierDocuments,categoryGrouping,storeSelect,waitingModal,seasonVueSelect,yearVueSelect,lineSelect},
  data() {
    return {

      onlySelection : false,
      refreshLine  : 0,
      lineId       : 0,
      waitModal    : {

        sentinel   : 0,
        show       : false,
        msg1       : 'ELABORAZIONE IN CORSO ...',
        msg2       : '' 

      },
      supplierDocuments : {'show':false},
      checkHide       : false,
      pdf_title       : 
      {        
        season : 'Tutte le stagioni',
        year   : 'Tutti gli anni ',
        group  : '',
        catGroup : ''
      },
      supplier        : 
      {
        Id            : 0,
        isActive      : true,
       
        optionBase    : false,
        required      : true

      },
      brand           :
      {
        supplierId    : 0,
        Id            : '%',
        required      : false,
        allBrands     : true

      },  
      store           : 
      {
        Id            : 0,
        isActive      : true,
       
        optionBase    : true,
        required      : false

      },
 
      season          : 
      {
        Id            : 0,
        isActive      : true,
        type          : true,
        optionBase    : false,
        required      : false,
        Ids           : '',
        selection     : []
      },
      season_year     : 
      {
        year          : 0,
        isActive      : true,
       
        optionBase    : true,
        required      : false,
        Ids           : '',
        selection     : []

      },
      department      : 
      {
        Id            : 0,
        isActive      : true,
        type          : true,
        optionBase    : false,
        required      : false,
        Ids           : '',
        selection     : ''
       
      },

      
      category        : 
      {
        Id            : 0,
        isActive      : true,
        
        optionBase    : true,
        required      : false,
        groupId       : 0
       
      },
      catGrouping     : {
        Id            : 0,
        isActive      : true,
        type          : true,
        optionBase    : true,
        required      : false
      },

      data1           : new Date().toISOString().slice(0,10),
      data2           : new Date().toISOString().slice(0,10),
      data3           : new Date().toISOString().slice(0,10),
      data4           : new Date().toISOString().slice(0,10),

      spinner         : false,
      spinner_pdf     : false,
      spinner_csv     : false,
      spinner1        : false,
      msg             : {

        title     : '',
        body      : '',
        type      : 0

      },
      
      items           : [],
      row_total       : [],
      grouping        : [],
      group_by        : 0,
      cols            : [],
      rows            : [],
      componentKey    : 0,
      detail          : [],
      isOpen          : [], 
      component       : '', 
      img             : '',
      refresh         : 100
      
    };
  },

  computed :{
    ...mapGetters(['company']),
   
  },
  directives: {
    focus: {
      // directive definition

      inserted : function(el) 
      {
        //el.focus();
      }

    }
  },
  mounted: function() {},
  created: function() {

    this.getGrouping()
    this.pdf_title.group = 'Brand'
  },
  methods: {
  
  setData3()
  {
    this.data3 = this.data1
  },    
  setLineId(lineId)
  {
      this.lineId = lineId
      
  },  
  setSelection()
  {
    this.items.forEach(item =>{
      item.export = 0
    })
    this.onlySelection = false
  },    
  setDataToExport(index)
  {
    if(this.items[index].row_type == 0 )
    {
      const pdf_export = this.items[index].export
      this.items[index].export = pdf_export == 0 ? 1 : 0
    }
    this.onlySelection = false
    this.items.forEach(item =>{
      if(item.export)
      {
        this.onlySelection = true
      }
    })
    
    
  },
  closeWaitingModal()
    {
      this.waitModal.show = false
      this.waitModal.sentinel = 0
      
    },  
  getDataDocuments()
  {
    this.supplierDocuments = {}
    this.supplierDocuments.show = true
    this.supplierDocuments.supplierId = this.supplier.Id
    this.supplierDocuments.seasonId = this.season.Ids
    this.supplierDocuments.brand = this.brand.Id
    this.supplierDocuments.season_year = this.season_year.Ids
    this.supplierDocuments.departmentId = this.department.Id
  },
    refreshData()
    {
      this.items=[]
      this.row_total=[]
      //this.brand.Id = '%'
      this.refresh++
      this.refreshLine++
    },
    
    setBrandId(brandId)
    {
      this.brand.Id = brandId
    },

    setGroupCategoryId(Id,e)
    {
      
      

      this.catGrouping.Id = Id
      
      this.pdf_title.catGroup = e.target.options[e.target.options.selectedIndex].text  
      if(Id == 0)
      {
        this.pdf_title.catGroup = ''
      }

      

    },
    getProductImg(item)
    {
       this.img = item.img
    },

    async getCSVData()
    {
      this.spinner_csv = true
       const sp          = {'sp' : 'spSellOutSupplierProductToCSV'}
       const data        = {
        'companyId'    : this.company.Id,
        'supplierId'   : this.supplier.Id,
        'data1'        : this.data1, 
        'data2'        : this.data2,
        'data3'        : this.data3,
        'data4'        : this.data4,
        'seasonId'     : this.season.Ids, 
        'year'         : this.season_year.Ids,
        'departmentId' : this.department.Id,
        'group_by'     : this.grouping[this.group_by]['group_id'],
        'catGroupId'   : this.catGrouping.Id,
        'categoryId'   : this.category.Id,
        'brand'        : this.brand.Id,
        'storeId'      : this.store.Id,
        'lineId'       : this.lineId
      }

      

      const json  = Object.assign(data, sp)
      this.spinner  = true
      return new  Promise( async (resolve, reject)  =>  {
      await api.post(json).then(res => {
        
            if(res.status==200)
            { 
              
              const data = res.data.recordsets[0] 
              resolve(data)
              
            }
            else if (res.status==500)
            {
              
              const data = []
              resolve(data)
              this.msg.title = 'ATTENZIONE '
              this.msg.body  = res.data
              this.msg.type  = 1
            }
            else
            {
              
              const data = []
              resolve(data)  
              this.msg.title = 'ATTENZIONE '
              this.msg.body  = res
              this.msg.type  = 1
            }

            }).catch(err => 
          {
	            
              this.msg.title = 'ATTENZIONE '
              this.msg.body  = err.message
              this.msg.type  = 1

          }).finally(() => {
              this.spinner_csv = false
          });

      })
          

    },



    async exportToCSV()
    {
      
      const data = await this.getCSVData()
    
      const lf = '\r\n'

      console.log(data)
    
      let csvData = "data:text/csv;charset=utf-8," 
      let row = ''
      let costPrice = 0
      data.forEach(item => {
        costPrice = 0
        if(item.bought_qty > 0 && item.bought_value > 0)
        {
          //costPrice = Math.ceil(item.bought_value / item.bought_qty)

        }
        
        row += item.barcode + ","
        row += item.brand + ","
        row += item.line + ","
        row += item.productId + ","
        row += item.season + '_' + item.season_year + ","
        row += item.cat_grouping + ","
        row += item.category + ","
        row += '"' + item.sku + '"' + ","
        row += item.color + ","
        row += item.size + ","
        row += item.bought_qty + ","
        row += item.costPrice + ","
        row += item.bought_value + ","
        row += item.sold_qty + ","
        row += item.sold_value_novat + ","
        csvData += row + lf
        row = ''


       
      })
      const encodedUri = encodeURI(csvData);
            const link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("download", "SELLOUT_PRODOTTI.csv");
            document.body.appendChild(link); // Required for FF

            link.click(); // This will download the data file named "my_data.csv".

    },
    async exportToPDF()
    {
      
     const detail = this.detail

     

     const groupRowDescription = (product) =>{

          const group = this.grouping[this.group_by].items.split(',')
          let text = ''
          group.forEach(item => {
            text = text + product[item] + ' '
          })

              return 'Totale ' +  text
      }

      const PerfomanceHeader = (row) =>
      {
          doc.setFontSize(6)
          doc.setFont("helvetica",'bold')
          //const row = 13
          
          doc.text('ACQUISTATO'  ,6,row)
          doc.text('VENDUTO'  ,27,row)
          doc.text('ACQUISTATO €'  ,50,row)
          doc.text('VENDUTO €'  ,70,row)
          doc.text('UTILE €'  ,90,row)
          
          doc.setFont("helvetica",'normal')
            
      }
      const productRowPerformance = (productId,row)  => {
        
        const item = this.items.filter(item => item.productId == productId) 
        
        doc.setFontSize(9)
        doc.text( item[0].acquistato_qty.toString() ,6,row)
        doc.text( item[0].venduto_qty.toString() ,27,row)
        doc.text( this.fmt1(item[0].acquistato_value),50,row)
        doc.text( this.fmt1(item[0].venduto_no_iva) ,70,row)

        if(Number(item[0].utile) <= 0)
        {
          doc.setTextColor(255, 0, 0) 
        }
        
        doc.text( this.fmt1(item[0].utile) ,90,row)

        doc.setTextColor(0, 0, 0) 
        
      }
      

      const doc = new jsPDF({orientation: "landscape" })
      const addFooters = doc => {
        const pageCount = doc.internal.getNumberOfPages()
        doc.setFont('helvetica', 'italic')
        doc.setFontSize(8)
      
        for (var i = 1; i <= pageCount; i++) {
          doc.setPage(i)
          if(i == 1)
          {
            header()
            descriptionHeader()
          }
          timeStamp()
          doc.text('Pag. ' + String(i) + ' di ' + String(pageCount), 270,205, {
          align: 'center'})
        }
      }

      const timeStamp = () =>
      {
        const d = new Date();
        const n = d.toLocaleDateString();
        const t = d.toLocaleTimeString();
        doc.setFontSize(7)
        doc.setTextColor(0, 0, 0)  
        doc.setFont("helvetica",'italic')
        doc.text( n + ' ' + t,  15, 205,null,null,'left');
        doc.setFont("helvetica",'normal')
      }

      const header = () =>{

            const data = new Date(this.data3).toLocaleDateString()

            doc.setDrawColor(0)
            doc.setFillColor(0,0,153)
            doc.roundedRect(3, 3, 292, 5,1,1,'FD')      


            doc.setFontSize(10)
            doc.setFont("helvetica",'bold')
            doc.setTextColor(255, 255, 255)  
            doc.text('ACQUISTATO/VENDUTO' + this.pdf_title.supplier + ' ' + this.data1 + ' ' + this.data2 , 150, 6.5,null,null,'center');
            doc.setTextColor(0, 0, 0)  
            
            doc.setFontSize(7)
            doc.setFont("helvetica",'italic')
            doc.text( 'Tipo raggruppamento ' + this.grouping[this.group_by].group_by,  150, 10.5,null,null,'right');
            doc.setFont("helvetica",'normal')


      }
      const addLastPage = () =>{
        doc.addPage()

          header()
          const add = 7
          doc.setFontSize(14)
          doc.setTextColor(0, 0, 0)  
          
          doc.text('TOTALE IMMESSO ARTICOLI  ' ,15,10 + add)
          doc.text('TOTALE VENDUTO ARTICOLI ' ,15,16 + add)
          doc.text('DELTA IMMESSO/VENDUTO ' ,15,22 + add)

          if(!this.checkHide)
          {
            doc.setTextColor(0, 0, 0) 
            doc.text('TOTALE IMMESSO VALORE (iva esc.) ' ,15,28 + add)
            doc.text('TOTALE VENDUTO VALORE (iva esc.) ' ,15,34 + add)
            doc.text('DELTA IMMESSO/VENDUTO ' ,15,40 + add)
            doc.text('COSTO VENDUTO (iva esc.)' ,15,46 + add)
          }
          
          doc.setTextColor(64, 0, 265) 
          doc.text(this.fmt2(this.row_total[0].acquistato_qty),150 ,10 + add,null,null,'right')
          doc.text(this.fmt2(this.row_total[0].venduto_qty),150 ,16 + add,null,null,'right')
          doc.text(this.row_total[0].delta_qty.toString(),150 ,22 + add,null,null,'right')

          if(!this.checkHide)
          {
            doc.setTextColor(64, 0, 265) 
            doc.text('€ ' + this.fmt1(this.row_total[0].acquistato_value) ,150 ,28 + add ,null,null,'right')
            doc.text('€ ' + this.fmt1(this.row_total[0].venduto_no_iva),150 ,34 + add,null,null,'right')
            doc.text(this.row_total[0].delta_venduto.toString(),150 ,40 + add,null,null,'right')
            doc.text('€ ' + this.fmt1(this.row_total[0].costo_venduto),150 ,46 + add,null,null,'right')
          }
          doc.setTextColor(0, 128, 0) 
          doc.setFontSize(11)
          doc.setFont('helvetica', 'bold')
          let row = 60
          this.items.forEach(item=>{
            if(item.row_type == 1)
            {
              const brand = item.brand ? item.brand : ''
              const line = item.line ? item.line : ''
              const cat_grouping = item.cat_grouping ? item.cat_grouping : ''
              const category = item.category ? item.category : ''
              
              doc.text(brand  + ' ' + line + ' ' + cat_grouping + ' ' + category  ,10 ,row)
              doc.text(this.fmt2(item.acquistato_qty),150 ,row,null,null,'right')
              doc.text(this.fmt2(item.venduto_qty),170 ,row,null,null,'right')
              doc.text(String(item.delta_qty),185 ,row,null,null,'right')
              if(!this.checkHide)
              {
                doc.text('€ ' + this.fmt1(item.acquistato_value),210 ,row,null,null,'right')
                doc.text('€ ' + this.fmt1(item.venduto_no_iva),240 ,row,null,null,'right')
                doc.text(String(item.delta_venduto),260 ,row,null,null,'right')
              }

              

              row += 5
            }
          })
          doc.setTextColor(0, 0, 0) 

      }
            
     
      

      const descriptionHeader = () =>
      {
          doc.setFontSize(6)
          doc.setFont("helvetica",'bold')
          const row = 13
          
        // doc.text('PROG. GRUPPO'  ,6,row)
        // doc.text('ID PRODOTTO'  ,27,row)
          doc.text('ID PRODOTTO'  ,20,row)
          doc.text('CODICE PRODOTTO'  ,48,row)
          doc.text('BRAND'  ,105,row)
          doc.text('LINEA'  ,156,row)
          doc.text('GRUPPO/CATEGORIA'  ,206,row)
          doc.setFont("helvetica",'normal')
            
      }

      

      const getQty  = (size,data) =>
      {
        
        let result = ''
        for (var i = 0; i < data.length; i += 1) 
        {
          let temp = data[i].split('|')
          if(temp[0]==size)
          {
            result = temp[1]
          }
        }
        return result
      }

      const productRow = (item,row) => {

        doc.setFont("helvetica", "bold")        
        
        doc.setDrawColor(0)
        doc.setFillColor(224,224,224)
        
        //doc.roundedRect(5, row - 1, 20, 7,1,1,'FD')       
        doc.setDrawColor(0)
        doc.setFillColor(224,224,224)
      
        /* Product ID 
        doc.roundedRect(26, row - 1, 20, 7,1,1,'FD') 
        */
        
        doc.roundedRect(20, row - 1, 20, 7,1,1,'FD') 

        doc.roundedRect(47, row - 1, 55, 7,1,1,'FD') 
        doc.roundedRect(103, row - 1, 50, 7,1,1,'FD') 
        doc.roundedRect(154, row - 1, 50, 7,1,1,'FD') 
        doc.roundedRect(205, row - 1, 90, 7,1,1,'FD') 
          
        doc.setFontSize(11)
        
        const rowItem = row + 3  
               
        

       // doc.text( String(item.row_group)  ,6,rowItem)       
        //doc.text( item.productId.toString() ,27,rowItem)
        doc.text( item.productId.toString() ,20,rowItem)
        doc.text( item.sku ,48,rowItem)
        doc.text( item.brand ,104,rowItem )
        doc.text( item.line ,155,rowItem)
        doc.text( item.cat_grouping + ' ' +  item.category ,207,rowItem )

        doc.setFontSize(6)
        doc.setFont("helvetica", "italic")        
        doc.text( item.description ,207,rowItem + 2.5 )
        doc.setFont("helvetica", "normal")    
        
       
        
      }
      const rowSizeHeader = (sizes,row) =>{

       
        let col = 75
        for (var i = 0; i < sizes.length; i += 1) 
        {

          doc.setDrawColor(0)
          //doc.setFillColor(240,240,240)
          doc.setFillColor(102,255,253)  
          doc.rect(col, row , 10, 6,'FD');
          doc.setFontSize(6.5)
          doc.setFont("helvetica",'bold')
          doc.text(sizes[i],col + 5,row + 3.5,null,null,'center')
          doc.setFontSize(8)
          //doc.setFont("helvetica",'bold')
          col += 10

        }
       
      }

      const colorSizes = (item,sizes,row) => {
                  
          let col = 75
          const itemRow = row
          // COLOR                        
          doc.rect(5, itemRow, 35, 6);
          doc.rect(col - 14 , itemRow, 12, 6)           
          doc.rect(col - 31 , itemRow, 14, 6) 
          doc.text(item.total.toString() ,col-13,itemRow + 4)
          
          if(item.color)

          {
            if(item.row_type == 0)
            {
              doc.text(item.color ,6,itemRow + 4)
            }
            doc.setTextColor(30, 144, 255)
            let row_type = 'Immesso'
            if(item.row_type == 1)
            {
              doc.setTextColor(40, 114, 51)  
              row_type = 'Venduto'
            }
            else if(item.row_type == 2)
            {
              doc.setTextColor(142, 64, 42)  
              row_type = 'Stock'
            }
           
            doc.text(row_type ,col - 30,itemRow + 4)
            doc.setTextColor(0, 0, 0)
                        
          }
       

          // SIZES
          for (var j = 0; j < sizes.length; j += 1) 
          {
                        
            doc.rect(col, row, 10, 6)            
            let data = []
            if(item.data)
            {
              data = item.data.split(',')
            }
            let size = sizes[j]
            let qty = getQty(size,data)
            if(qty)
            {
              
              doc.setFontSize(8)
              doc.setFont("helvetica",'normal')
              doc.text(qty, col + 2,itemRow + 4)
              doc.setFont("helvetica",'bold')
              
            }
            
            col += 10

          }
          

      }      

      
      
      let firstRow   = 15
      const lastRow  = 185

      const createCard = (product,items,sizes,row) => 
      {                
        
        let rowCard = row
        if(rowCard > lastRow)
        {
         
          doc.addPage()
          rowCard = firstRow
         
        }

        productRow(product,rowCard)        
        rowCard = rowCard + 7.5
        
        if(rowCard > lastRow)
        {
          
          doc.addPage()
          rowCard = firstRow
        }
        
        if(!this.checkHide)
        {
          rowCard = rowCard + 1
          PerfomanceHeader(rowCard)
          rowCard = rowCard + 3
          productRowPerformance(product.productId,rowCard)
          rowCard = rowCard + 2
        }

        rowSizeHeader(sizes,rowCard)        
        rowCard = rowCard + 6

        if(rowCard > lastRow)
        {
          doc.addPage()
          rowCard = firstRow
        }
                
        for (var i = 0; i < items.length; i += 1) 
        {
          
          if(rowCard > lastRow)
          {
            doc.addPage()
            rowCard = firstRow
          } 

          colorSizes(items[i],sizes,rowCard)           
          rowCard = rowCard + 6
         

        }  

        return rowCard
      }
      
      
      
      let row = firstRow
      let row_count = 0
      let productId = 0    
      this.items.forEach(item=>
      {
        
        
        if(item.productId )
        {
          productId =  0
          if(this.onlySelection)
          { 
            if(item.export)         
            {
             
              productId = item.productId
            
            }
          }
          else
          {
            productId = item.productId
          }
          if(productId)
          {
            const data   = detail.filter(product => product.productId == productId )                
            const header = data[0].header.split('|')
            row_count    = createCard(item,data,header,row)                 
            row          = row_count + 4
          }  
          
          
                
        }

      }
      )




      if(!this.onlySelection)
      {
        addLastPage()  
      }

      

      addFooters(doc)
      window.open(URL.createObjectURL(doc.output("blob")))

      
      
      
    },

    pdf()
    {            
      this.exportToPDF()
    },
    
    setStoreId(storeId,e)
    {
      this.store.Id        = storeId
      this.pdf_title.store = e.target.options[e.target.options.selectedIndex].text     
      if(storeId == 0)
      {
        this.pdf_title.store = ''    
      }
      
    },

    setSupplierId(supplierId,text)
    {  
     
      this.supplier.Id = supplierId
      this.pdf_title.supplier = text  
      this.brand.supplierId = supplierId
      this.refresh++
      this.refreshLine++
      
    },

    
    setDepartmentId(Ids,text)
    { 

      this.pdf_title.department = text
      this.department.selection = Ids
      let departmentIds = ''
      if (Ids.length > 0)
      {
        departmentIds = Ids.join() 
      }
      this.department.Ids = departmentIds

    },
    /*
    setSeasonId(seasonId,e)
    {           
      this.season.Id        = seasonId
      this.pdf_title.season = e.target.options[e.target.options.selectedIndex].text
    }, 
    */
    /*
    resetData()
  {
    this.data1 = null
    this.data2 = null

  },
  */
    setSeasonId(Ids,text)
    {   
      
       /*
        this.season.Id = seasonId
        this.title.season = e.target.options[e.target.options.selectedIndex].text
        */
      //this.resetData() 
      this.pdf_title.season = text  
      this.season.selection = Ids
      let seasonIds = ''
      if (Ids.length > 0)
      {
        seasonIds = Ids.join() 
      }
       
      this.season.Ids = seasonIds
      
      

    }, 

    setYear(Ids,text)
    {
      
      let season_yearIds = ''      
      this.pdf_title.year   = text
      this.season_year.selection = Ids
      /*
      if(year == 0)
      {
        this.pdf_title.year = 'Tutti gli anni '
      }
      */  
       
       if (Ids.length > 0)
      {
        season_yearIds = Ids.join() 
      }
      this.season_year.Ids = season_yearIds
      //console.log(this.season_year.Ids)
      

    },     
    setCategoryId(categoryId,e)
    {
       

        this.category.Id = categoryId
        this.pdf_title.category = e.target.options[e.target.options.selectedIndex].text                
        if(categoryId==0)
        {
          this.pdf_title.category = 'Tutte le stagioni'                  
        }

        

    },
    setGroup(e) 
    {
      
      //this.pdf_title.group = this.grouping[e.target.value].group_by
        
    },
   
    submit() 
    { 
      let date1 = new Date(this.data1);
      let date3 = new Date(this.data3);
      let Difference_In_Time = date3.getTime() - date1.getTime()
      let Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
      
      if(Difference_In_Days > 365)
      {
        //return
      }

      this.getData()
    },  
    
    async getGrouping()
    {
      this.grouping = []
      var json        = {'sp' : 'spGrouping'}
      
      this.spinner  = true
      await api.post(json).then(res => {
        
            if(res.status==200)
            { 
              this.grouping = res.data.recordsets[0]
              
            }
            else if (res.status==500)
            {
              

              this.msg.title = 'ATTENZIONE '
              this.msg.body  = res.data
              this.msg.type  = 1
            }
            else
            {
              

              this.msg.title = 'ATTENZIONE '
              this.msg.body  = res
              this.msg.type  = 1
            }

            }).catch(err => 
          {
	            
              this.msg.title = 'ATTENZIONE '
              this.msg.body  = err.message
              this.msg.type  = 1

          }).finally(() => {
              this.spinner = false
          });


    },

    async openDetail(index)
    {
      
      if(this.items[index]['row_type'] > 0)
      {
          return
      }
      
      
      this.component = ''
      this.isOpen=[]
      this.spinner1 = true
      this.isOpen[index]=true
    

      var arr = []
      arr = this.detail.filter(item => item.productId == this.items[index]['productId'])
     
      
            
            var cols = []
            
            this.cols = []
            this.rows = []
            
           
            this.cols.push('Colore')
            this.cols.push('Tipo')
           
            this.cols.push('Totale')
             
            cols = arr[0]['header'].split('|')

            cols.forEach(item=>{
              this.cols.push(item)
            })
            arr.forEach(item=>{
              let sizeList =   this.getSizeList(item.data)
              
              let tmp = {'Colore':item.color,'Tipo':item.tipo,'Totale':item.total}
              let obj = {}
              obj = Object.assign(obj,tmp)
              obj = Object.assign(obj,sizeList)
              this.rows.push(obj)

              
            })

            
            this.component = 'productDetail'
            this.componentKey++
            this.spinner1 = false


    },

    getSizeList(data)
    { 
      let obj = {}
      if(data)  
      {
      let arr_data = data.split(',')

      arr_data.forEach(item =>{
        let propertyName = ''
        let tmp = {}
        let col  = item.split('|')

        propertyName = col[0]
        
        tmp[propertyName] = col[1]
      
        obj =  Object.assign(obj,tmp);
        

      })
      }
      return obj

    },

    async getData() {
      
      this.row_total = []
      this.items = []
      this.component = ''  
      
      this.msg.title = ''
            
      const sp = {'sp' : 'spSellOutSupplierProduct'}                 
      const data  = {
        'companyId'    : this.company.Id,
        'supplierId'   : this.supplier.Id,
        'data1'        : this.data1, 
        'data2'        : this.data2,
        'data3'        : this.data3,
        'data4'        : this.data4,
        'seasonId'     : this.season.Ids, 
        'year'         : this.season_year.Ids,
        'departmentId' : this.department.Ids,
        'group_by'     : this.grouping[this.group_by]['group_id'],
        'catGroupId'   : this.catGrouping.Id,
        'categoryId'   : this.category.Id,
        'brand'        : this.brand.Id,
        'storeId'      : this.store.Id,
        'lineId'       : this.lineId
      }
      console.log(data)
      const json  = Object.assign(data, sp)
      
      

      this.spinner = true
      this.waitModal.show = true
      await api.post(json).then(res => {
         
          if(res.status==200)
            {
             
              this.waitModal.sentinel = 1 
              res.data.recordsets[0].forEach(item =>{
                  if(item.row_type ==0 )
                  {
                    item.export = 0
                  }
              })

              
             
              this.detail = res.data.recordsets[1]

              this.items = res.data.recordsets[0].filter(item => item.row_type == 0 || item.row_type == 1)    
             
              this.items.forEach(item=>{
              
               /* 
              if(item.row_type == 0)
              {
                item.selected = 1  
              
              }
                */
              
              
              if(item.row_type == 1)
              {
                //item.selected = 1
                item.season = 'Tot. Raggruppamento'
                item.season_year = ''
                item.department = ''
              }
            })
            
            this.row_total = res.data.recordsets[0].filter(item=>item.row_type==3)
            
            if(this.items.length==0)
              {
                this.msg.title = 'ATTENZIONE '
                this.msg.body = 'DATI INESISTENTI.'
                this.msg.type  = 1
              }

            }
            else if (res.status==500)
            {
              this.waitModal.sentinel = 3
              this.msg.title = 'ATTENZIONE '
              this.msg.body = res.data
              this.msg.type  = 1
              
            }
          
          else
          {
            this.waitModal.sentinel = 2
            this.msg.title = 'ATTENZIONE '
            this.msg.body = res
            this.msg.type  = 1
                
                        

          }
      }).catch(err=>{
            this.waitModal.sentinel = 3
            this.msg.title = 'ATTENZIONE '
            this.msg.body = err.message
            this.msg.type  = 1
              

      }).finally(() => {
          this.spinner = false
        });
      
 

    }
  }
};
</script>
<style scoped>


.my-custom-scrollbar {
position   : relative;
height     : 800px;
overflow   : auto;
}

.pointer:hover
{
  background-color : blue;
  color            : white;
  cursor           : pointer;
}


.table thead  tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   : hwb(45 4% 9%); 
    color        : black;   
    position     : sticky;
    top          : 0;
    z-index      : 10;

 }
 .table tfoot  tr:nth-child(1) td
 {

    font-family  : 'Roboto Condensed';
    font-size    : 22px;
    background   : rgb(195, 230, 98);
    font-weight  : bold;
    color        : black;   
    position     : sticky;
    bottom       : 0;
    z-index      : 10;
    height       : 50px;

 }




.table-wrapper-scroll-y {
display: block;
}
.table th:first-child
{
  border-radius : 0 0 0 10px;
}
.table th:last-child
{
  border-radius : 0 10px 0 0;  
}



h4 {
  font-family  : 'Roboto Condensed';
  font-size    : 20px;
}
.form-check-label{
  cursor:pointer
}
.custom-control-label{
  cursor:pointer;
  color:blue;
  font-weight: bold;
}
 .dotRed
{
  height: 15px;
  width: 15px;
  
  border-radius: 50%;
  display: inline-block;
  background-color:red}

  .card-header
{
  height: 45px;
}
</style>